import { useSelector, useStore } from '@/stores/hooks'
import { getLoadingState, type LoadingState } from '@/stores/loading'
import type { Tracker } from '@/stores/track/track'
import { mapOrd, rawOrd } from '@lc/libarray'
import { useEffect } from 'react'
import { useExecutor } from '../useExecutor'

export type UseTrack = {
	id: string
	status: LoadingState['status']
	error?: string
}

export function useTrack<T>(
	track: Tracker<T>,
	params: { level: number; interval: number } & T,
): UseTrack {
	const id = track.id(params)
	const store = useStore()
	const executor = useExecutor()
	const loadingState = useSelector(state => getLoadingState(state, id))

	useEffect(() => {
		return track({ store, executor, ...params })
	}, [
		store,
		executor,
		...Object.entries(params)
			.sort(mapOrd(rawOrd, x => x[0]))
			.flat(),
	])

	const status = loadingState?.status ?? 'pending'
	if (loadingState?.status === 'failed') {
		return { id, status, error: loadingState.error }
	} else {
		return { id, status }
	}
}
